import CommentBoxPanel from './CommentBoxPanel';
import CommentBoxPanelContainer from './CommentBoxPanel.container';
export default CommentBoxPanelContainer(CommentBoxPanel);

//# sourceMappingURL=index.js.map